import { ChangeEvent } from 'react'

export const formatCpfNumber = (cpf: string) => {
  const digits = cpf.replace(/\D/g, '')
  if (digits.length === 11)
    return `${digits.substring(0, 3)}.${digits.substring(3, 6)}.${digits.substring(6, 9)}-${digits.substring(9, 11)}`

  return digits
}

const cpfFormater = (input: HTMLInputElement) => {
  const value = input.value
  input.value = formatCpfNumber(value)
}

export const cpfMask = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    cpfFormater(event.target)
  }
}

export const validateCpf = (cpf: string): boolean => {
  cpf = cpf.replace(/[^\d]+/g, '')
  if (cpf.length !== 11) return false

  if (/^(\d)\1+$/.test(cpf)) return false

  let sum = 0
  let remainder

  for (let i = 1; i <= 9; i++)
    sum += parseInt(cpf.substring(i - 1, i), 10) * (11 - i)
  remainder = (sum * 10) % 11
  if (remainder === 10 || remainder === 11) remainder = 0
  if (remainder !== parseInt(cpf.substring(9, 10), 10)) return false

  sum = 0
  for (let i = 1; i <= 10; i++)
    sum += parseInt(cpf.substring(i - 1, i), 10) * (12 - i)
  remainder = (sum * 10) % 11
  if (remainder === 10 || remainder === 11) remainder = 0
  if (remainder !== parseInt(cpf.substring(10, 11), 10)) return false

  return true
}